import { FundView } from "~/common/fund/FundView";
import { Logger } from "~/utils/logger";
const logger = new Logger("fund-widget", "info");

export const FundWidget = (props: {
  list: {
    id: string | undefined | null;
    name: string;
  };
  title: string;
  randomize: string;
  showFundDetails: string;
  listView: string;
  image: {
    id: string;
  } | null;
}) => {
  logger.debug("props", props);

  if (!props.list.id) {
    return <div>No list selected.</div>;
  }

  const bannerImage =
    props.image && props.image.id !== "" ? Number(props.image.id) : undefined;

  return (
    <FundView
      title={props.title}
      fundId={props.list.id}
      fundName={props.list.name}
      randomize={props.randomize === "yes"}
      showFundDetails={props.showFundDetails === "yes"}
      bannerImage={bannerImage}
      listView={props.listView === "yes"}
    />
  );
};
